/**
 * Status of the fastest lap of the day; also the row class in the lists
 * @type {string}
 */
export const LAP_FASTEST_DAY = 'fastest-day'

/**
 * Status of the fastest lap in a group; also the row class in the lists
 * @type {string}
 */
export const LAP_FASTEST_GROUP = 'fastest-group'

/**
 * Status of a lap with cones or a fault
 * @type {string}
 */
export const LAP_INVALID = 'invalid'

/**
 * Chart colours per lap status, the same as the row colours in DataTable.less
 * @type {Object<string, string>}
 */
export const LAP_COLOURS = {
  [ LAP_FASTEST_DAY ]: '#a500a5',
  [ LAP_FASTEST_GROUP ]: '#008000',
  [ LAP_INVALID ]: '#ffa500'
}

/**
 * Check whether a lap had cones or a fault
 * @param {Object} row lap
 * @returns {boolean} whether the lap does not count
 */
export const isInvalidLap = ( row ) => row.penalty > 0 || ( !!row.comment && row.comment !== '' )

/**
 * Get whether a lap is the fastest of the day or of its group
 * @param {Object} row lap
 * @param {Object|null} fastestDay fastest lap of the day
 * @param {Array<Object>} fastestGroup fastest lap per group
 * @returns {string} LAP_FASTEST_DAY, LAP_FASTEST_GROUP or empty
 */
export const getFastestStatus = ( row, fastestDay = null, fastestGroup = [] ) =>
{
  if ( fastestDay && row.laptime === fastestDay.laptime ) return LAP_FASTEST_DAY
  if ( fastestGroup && fastestGroup.filter( d => d.car === row.car && d.laptime === row.laptime ).length === 1 ) return LAP_FASTEST_GROUP
  return ''
}

/**
 * Get the chart colour of a lap, as in the lists: cones or a fault first, then fastest of the day or group
 * @param {Object} row lap
 * @param {Object|null} fastestDay fastest lap of the day
 * @param {Array<Object>} fastestGroup fastest lap per group
 * @param {string} fallback colour of other laps
 * @returns {string} colour
 */
export const getLapColour = ( row, fastestDay, fastestGroup, fallback ) =>
{
  if ( isInvalidLap( row ) ) return LAP_COLOURS[ LAP_INVALID ]
  return LAP_COLOURS[ getFastestStatus( row, fastestDay, fastestGroup ) ] || fallback
}
